import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { INZorroOutput } from '../../../core/models/common';
import { ZorroTableComponent } from '../custom-table/zorro-table.component';

@Component({
  selector: 'app-ui-object-table',
  standalone: true,
  imports: [CommonModule, FormsModule, ZorroTableComponent],
  templateUrl: './ui-object-table.component.html',
  styleUrl: './ui-object-table.component.scss'
})
export class UiObjectTableComponent {

  @Input() tableData: any = {
    columns: [
      {
        key: 'rowSelect',
        display_name: '',
        headerStyles: { 'width': 0 },
        _config: {
          type: 'checkbox'
        }
      },
      {
        key: 'a',
        display_name: 'Column A'
      },
      {
        key: 'b',
        display_name: 'Column B',
        _config: {
          type: 'image_with_text',
          prefixImage: {
            targetKey: 'source',
            values: {
              'mozilla': 'assets/images/virtusa-icons/firefox.png',
              'chrome': 'assets/images/virtusa-icons/chrome.png',
              'edge': 'assets/images/virtusa-icons/edge.png'
            }
          },
          suffixImage: {
            targetKey: 'isShl',
            values: {
              true: 'assets/images/virtusa-icons/shl.png'
            }
          }
        },
        _editConfig: {
          type: 'input'
        }
      },
      {
        key: 'c',
        display_name: 'Column C'
      }
    ],
    items: [
      {
        a: 'kdsd',
        b: 'value 1',
        c: 'value 2',
        source: 'mozilla',
        isShl: true
      },
      {
        a: 'kdsd',
        b: 'value 1',
        c: 'value 2'
      }
    ]
  };

  /**
     * Output event emitted when row or column selection changes.
     */
  @Output() onRowSelect = new EventEmitter<INZorroOutput>();

  @ViewChild(ZorroTableComponent) zorroTableComponent!: ZorroTableComponent;

  isSelectAll = false;
  selectedRows: any[] = [];

  onDelete() {
  }

  onEdit() {
  }

  /**
     * Handle row or column selection from the ZorroTableComponent.
     * @param event Selection event from the table.
     */
  onTableRowSelect(event: INZorroOutput) {
    if (event.type === 'rowSelect' && Array.isArray(event.data)) {
      this.selectedRows = event.data;
    }
    this.onRowSelect.emit(event);

    if (this.selectedRows.length !== this.tableData.data.length) {
      this.isSelectAll = false;
    } else {
      this.isSelectAll = true;
    }
  }


  onSelectAllRows(event: any) {
    const isChecked = event.target.checked;

    if (isChecked) {
      // Deselect any columns that were selected
      this.tableData.columns.forEach((col: any) => {
        col.select = false;
      });

      // Select all rows
      this.tableData.items.forEach((row: any) => {
        row.select = true;
      });

      this.selectedRows = [...this.tableData.items];
    } else {
      // Deselect all rows
      this.tableData.items.forEach((row: any) => {
        row.select = false;
      });

      this.selectedRows = [];
    }

    // Notify the table to refresh and emit the selection
    this.zorroTableComponent.reOrderExpandableRows();
    this.onRowSelect.emit({
      type: "rowSelect",
      select_type: isChecked ? "all" : "",
      data: this.selectedRows,
    } as any);
  }
}
